import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propStr } from '../../../../helpers/custom-prop-types';
import AboutAccordion from './AboutAccordion';
class Description extends Component {
    constructor(props) {
        super(props);
        this.onChange = (e) => {
            this.setState({
                isOpen: e.currentTarget.checked,
            });
        };
        this.onTruncate = (isTruncate) => {
            this.setState({ isTruncate });
        };
        this.state = {
            isOpen: false,
            isTruncate: false,
        };
    }
    render() {
        const { description } = this.props;
        const { isOpen, isTruncate } = this.state;
        return (_jsx("section", { children: _jsxs("div", Object.assign({ className: 'about-box is-free' }, { children: [_jsx("h2", Object.assign({ className: 'about-title is-free accordion-description-title' }, { children: "DESCRIPTION" })), _jsxs("div", Object.assign({ className: 'about-text about-text-pad' }, { children: [!isOpen && (_jsx(TruncateMarkup, Object.assign({ lines: 5, onTruncate: this.onTruncate }, { children: _jsx("pre", Object.assign({ className: 'is-truncate' }, { children: description })) }))), (isOpen || isTruncate) && (_jsx(AboutAccordion, Object.assign({ keyId: 'accordion-description', onChange: this.onChange, openText: 'View More' }, { children: _jsx("pre", Object.assign({ className: 'is-truncate overflow-y-hidden' }, { children: description })) })))] }))] })) }));
    }
}
Description.propTypes = {
    description: propStr(),
};
Description.defaultProps = {
    description: '',
};
export default Description;
